module.exports = __webpack_public_path__ + "static/media/boy-17.596c6007.svg";